import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'XML чек',
      title: 'Получить XML чек',
      executeAction: 'Получить',
      errorMessage: 'Ошибка',
    }
  }
}